import { useNavigate, useParams } from "react-router-dom";
import { useGetSubAdminDetailQuery } from "../../store/api/manageAPI";
import moment from "moment";
import { CircularProgress } from "@mui/material";
import { USER_TYPES } from "../../constants/enums";

const getRoleLabel = (role: number) => {
  const entry = Object.entries(USER_TYPES).find(([_, value]) => value === role);
  return entry ? entry[0].replace(/_/g, " ").toLowerCase().replace(/\b\w/g, c => c.toUpperCase()) : "Unknown";
};

const SubadminDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { data: detailData, isLoading } = useGetSubAdminDetailQuery(
    { id: id || "" },
    { skip: !id }
  );

  const detail = detailData?.data;

  if (isLoading) {
    return <div style={{ display: 'flex', justifyContent: 'center', padding: '50px' }}><CircularProgress /></div>;
  }

  if (!detail) { // Handle case where id is invalid or data not found
    return <div>Sub-admin not found</div>;
  }

  return (
    <>
      <div className="main_title">
        <h1>Sub-Admin Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button>
          {' '} - <button onClick={() => navigate("/manage-subadmin")}>Manage Sub-Admin</button>
          {' '} - Sub-Admin Detail
        </p>
      </div>

      <div className="cards view_page">
        <div className="gap_p">
          <div className="vew_img w_100">
            <h6>Image</h6>
            <figure>
              <img
                alt="user"
                src={detail.image || "/static/images/user_placeholder.png"}
                onError={(e) => {
                  (e.target as HTMLImageElement).src = "/static/images/user_placeholder.png";
                }}
              />
            </figure>
          </div>
          <div className="w_33">
            <h6>Name</h6>
            <p>{detail.fullName || detail.firstName + " " + detail.lastName}</p>
          </div>
          <div className="w_33">
            <h6>Email Id</h6>
            <p>{detail.email}</p>
          </div>
          <div className="w_33">
            <h6>Phone Number</h6>
            <p>{detail.countryCode} {detail.phone}</p>
          </div>
          <div className="w_33">
            <h6>Role</h6>
            <p>{getRoleLabel(detail.role)}</p>
            {/* Note: Role is currently a number. Ideally map to string if enum exists or simply display ID for now as per requirement to show data */}
          </div>
          <div className="w_33">
            <h6>Created Date</h6>
            <p>{moment(detail.createdAt).format("DD MMMM YYYY")}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default SubadminDetail;
